import { PushNotificationService } from 'data/services';
import { PushNotificationServiceInterface } from 'domain/services';
import {
  makePushNotification,
  makeSchedulePushNotification,
  makeScheduledPushNotificationList,
  makeScheduledPushNotificationGetById,
  makeUpdateScheduledPushNotification,
  makeCancelScheduledPushNotification,
  makeReschedulePushNotification,
  makeRecurringPushNotification,
  makeRecurringPushNotificationList,
  makeRecurringPushNotificationGetById,
  makeCancelRecurringPushNotification,
  makeUpdateRecurringPushNotification,
  makeResumeRecurringPushNotification,
  makePauseRecurringPushNotification,
} from 'main/factories/usecases/push-notification';

export const makePushNotificationService =
  (): PushNotificationServiceInterface => {
    return new PushNotificationService({
      pushNotification: makePushNotification(),
      schedulePushNotification: makeSchedulePushNotification(),
      scheduledPushNotificationList: makeScheduledPushNotificationList(),
      cancelScheduledPushNotification: makeCancelScheduledPushNotification(),
      scheduledPushNotificationGetById: makeScheduledPushNotificationGetById(),
      updateScheduledPushNotification: makeUpdateScheduledPushNotification(),
      reschedulePushNotification: makeReschedulePushNotification(),
      recurringPushNotification: makeRecurringPushNotification(),
      recurringPushNotificationList: makeRecurringPushNotificationList(),
      recurringPushNotificationGetById: makeRecurringPushNotificationGetById(),
      updateRecurringPushNotification: makeUpdateRecurringPushNotification(),
      cancelRecurringPushNotification: makeCancelRecurringPushNotification(),
      pauseRecurringPushNotification: makePauseRecurringPushNotification(),
      resumeRecurringPushNotification: makeResumeRecurringPushNotification(),
    });
  };
